import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import calendarSidebarReducer from "./calendarSidebarSlice";
import { notesCustomApi } from "./services/notesCustomApi";
import { schedulerApi } from "./services/scheduler";
import { authSlice } from "./authSlice";

export const store = configureStore({
  reducer: {
    calendarSidebar: calendarSidebarReducer,
    auth: authSlice.reducer,
    [schedulerApi.reducerPath]: schedulerApi.reducer,
    [notesCustomApi.reducerPath]: notesCustomApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      schedulerApi.middleware,
      notesCustomApi.middleware,
    ),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
